import React from "react";

export const DataComp = React.memo(
  ({
    src,
    alt,
    ee,
    h2Title,
    p_Desc,
    post_location,
    post_date,
    withZoom,
    loading,
    srcSet
  }) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };



    return (
      <div
        className={ee}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "15px",
        }}
      >
        <figure className={withZoom ? "image-container" : ""}>
          <img
            src={src}
            srcSet={srcSet}
            className="eventImg"
            alt={alt}
            width="100%"
            loading={loading}
          />
        </figure>
        <div>
          <h2 style={{ fontSize: "1.5rem" }} className="fw-bold  hoverHead ">{h2Title}</h2>
          <p style={{ fontSize: "12px" }}>
            <span className="fw-bold">{post_location}</span>
          </p>
          <p className="just-text line-clamp mt-1" style={{ fontSize: "12px" }}>
            {p_Desc}
          </p>
        </div>
      </div>
    );
  }
);
